// store/slices/slrmBillsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchSlrmBillsByHouseThunk = createAsyncThunk(
  "slrmBills/fetchByHouse",
  async (home_id, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/api/slrm-bills/house/${home_id}`);
      if (!data?.success) return rejectWithValue(data?.message || "Failed");
      return data.data || [];
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

export const deleteSlrmBillThunk = createAsyncThunk(
  "slrmBills/delete",
  async ({ sb_id }, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/api/slrm-bills/${sb_id}`);
      if (!data?.success) return rejectWithValue(data?.message || "Failed");
      return sb_id;
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message);
    }
  }
);

const slrmBillsSlice = createSlice({
  name: "slrmBills",
  initialState: {
    list: [],
    loading: false,
    error: null,
    deletingId: null,
  },
  reducers: {
    clearSlrmBillsError: (s) => {
      s.error = null;
    },
    clearSlrmBillsList: (s) => {
      s.list = [];
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchSlrmBillsByHouseThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchSlrmBillsByHouseThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.list = a.payload || [];
    });
    b.addCase(fetchSlrmBillsByHouseThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(deleteSlrmBillThunk.pending, (s, a) => {
      s.deletingId = a.meta.arg?.sb_id || null;
      s.error = null;
    });
    b.addCase(deleteSlrmBillThunk.fulfilled, (s, a) => {
      s.deletingId = null;
      s.list = (s.list || []).filter((x) => String(x.sb_id) !== String(a.payload));
    });
    b.addCase(deleteSlrmBillThunk.rejected, (s, a) => {
      s.deletingId = null;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearSlrmBillsError, clearSlrmBillsList } = slrmBillsSlice.actions;
export default slrmBillsSlice.reducer;